// extracted by mini-css-extract-plugin
export var active = "_1z-d";
export var blink = "_1z-e";
export var container = "_1z-5";
export var controls = "_1z-0";
export var controlsRight = "_1z-1";
export var fakeCursor = "_1z-c";
export var hidden = "_1z-b";
export var quillContainerSmall = "_1z-7";
export var quillEditor = "_1z-6";
export var quillEditorSmall = "_1z-8";
export var quillFormatButtons = "_1z-a";
export var quillToolbar = "_1z-9";
export var removePadding = "_1z-2";
export var state = "_1z-3";
export var stateTitle = "_1z-4";